<template>
  <layout>
    <div>
      <div class="login-form-container">
        <div class="login-form-inner">
          <div class="logo">
            <img src="assets/logo.png" alt="" />
          </div>
          <form id="login-form" @submit.prevent="submit">
            <b-field
              label="Email"
              :type="{ 'is-danger': errors?.email }"
              :message="errors?.email"
            >
              <b-input
                type="email"
                v-model="form.email"
                placeholder="Email"
              ></b-input>
            </b-field>
            <b-field
              label="Password"
              :type="{ 'is-danger': errors?.password }"
              :message="errors?.password"
            >
              <b-input
                type="password"
                placeholder="Password"
                v-model="form.password"
              ></b-input>
            </b-field>
            <b-field>
              <b-checkbox v-model="form.remember">Remember me</b-checkbox>
            </b-field>
            <b-button
              class="is-primary"
              :loading="form.isSending"
              native-type="submit"
              >Sign In</b-button
            >
          </form>
        </div>
        <inertia-link href="/forgot-password">
          <b-button class="forgot-password is-dark">
            Forgot your password?
          </b-button>
        </inertia-link>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from './Layout';

export default {
  metaInfo: { title: 'Login' },
  components: {
    layout,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember: false,
        isSending: false,
      },
    };
  },
  methods: {
    submit() {
      const data = {
        email: this.form.email,
        password: this.form.password,
        remember: this.form.remember,
      };
      this.$inertia.post(this.route('login'), data, {
        onStart: () => (this.form.isSending = true),
        onFinish: () => (this.form.isSending = false),
      });
    },
  },
};
</script>
